
export function buildModularSurvey({ surveyComponents }) {    // get questions and enabled data
    const modularSurvey = []

    const _openSurvey = surveyComponents.filter(
        br => br?.enabled === true
            && br?.editable === true
            && br?.completed === false
            && br?.question?.sort_order
            && br?.ask_again?.value > 0)

    _openSurvey.map(op => {
        if (op?.enabled === true) {
            modularSurvey.push(op)
        }
        return null

    })

    return modularSurvey
}

